import { UserRow } from "services/api/users/types";
import { Badge } from "ui/components/Badge";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import { ReactSVG } from "react-svg";

export const USER_SEARCH_COLUMNS = (
  onEmailClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    email: string
  ) => void,
  onPhoneClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    phone: string
  ) => void,
  onGoogleMapClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    address: string
  ) => void
): Column[] => [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: UserRow) => {
      const imageUrl = row.avatar;
      const initials = `${row.firstName?.toString().charAt(0).toUpperCase()} ${row.lastName?.toString().charAt(0).toUpperCase()}`;
      return (
        <div className="gap-3 items-center inline-flex text-md font-medium truncate text-sky-600 hover:text-sky-900 text-sm cursor-pointer">
          <TableIcon imageUrl={imageUrl} initials={initials} />
        </div>
      );
    },
  },
  {
    title: "admin.user.search.name",
    field: "",
    type: ColumnTypes.custom,
    render: (row: UserRow) => {
      return (
        <div className="text-md">
          {row.firstName} {row.lastName}
        </div>
      );
    },
  },
  {
    title: "admin.user.search.username",
    field: "userName",
    type: ColumnTypes.string,
  },
  {
    title: "admin.user.search.oib",
    field: "oib",
    type: ColumnTypes.string,
  },
  {
    title: "admin.user.search.email",
    field: "",
    type: ColumnTypes.custom,
    render: (row: UserRow) => {
      return (
        <div>
          {row.email && (
            <span
              onClick={(e) => onEmailClick(e, row.email)}
              className="inline-flex items-center gap-1.5 text-md font-medium truncate text-sky-600 hover:text-sky-700 cursor-pointer"
            >
              <ReactSVG
                src="/media/icons/email.svg"
                className="w-4 h-4 stroke-sky-500 shrink-0"
              />
              {row.email}
            </span>
          )}
        </div>
      );
    },
  },
  {
    title: "admin.user.search.phone",
    field: "",
    type: ColumnTypes.custom,
    render: (row: UserRow) => {
      return (
        <div className="flex flex-col gap-1">
          {row.mobilePhoneNumber && (
            <span
              onClick={(e) => onPhoneClick(e, row.mobilePhoneNumber)}
              className="inline-flex items-center gap-1.5 text-md font-medium truncate text-sky-600 hover:text-sky-700 cursor-pointer"
            >
              <ReactSVG
                src="/media/icons/phone.svg"
                className="w-4 h-4 stroke-sky-500 shrink-0"
              />
              {row.mobilePhoneNumber}
            </span>
          )}
          {row.phoneNumber && (
            <span
              onClick={(e) => onPhoneClick(e, row.phoneNumber)}
              className="inline-flex items-center gap-1.5 text-sm font-normal truncate text-sky-600 hover:text-sky-700 cursor-pointer"
            >
              <ReactSVG
                src="/media/icons/phone.svg"
                className="w-4 h-4 stroke-sky-500 shrink-0"
              />
              {row.phoneNumber}
            </span>
          )}
        </div>
      );
    },
  },
  {
    title: "Adresa",
    field: "",
    type: ColumnTypes.custom,
    render: (row: UserRow) => {
      const address = [row.addressLine1, row.addressPostalCode, row.addressCity]
        .filter(Boolean)
        .join(", ");
      return (
        <div>
          {address && (
            <span
              onClick={(e) => onGoogleMapClick(e, address)}
              className="inline-flex items-center gap-1.5 text-md font-medium truncate text-sky-600 hover:text-sky-700 cursor-pointer"
            >
              <ReactSVG
                src="/media/icons/map.svg"
                className="w-4 h-4 stroke-sky-500 shrink-0"
              />
              {row.addressLine1}
            </span>
          )}
        </div>
      );
    },
  },
  {
    title: "admin.user.search.roles",
    field: "",
    type: ColumnTypes.custom,
    render: (row: UserRow) => {
      return (
        <div className="text-md">
          <Badge
            variant="info"
            text={row.roles?.map((role) => role.name).join(", ")}
          />
        </div>
      );
    },
  },
];
